export var LogType;
(function (LogType) {
    LogType[LogType["GenericError"] = 1] = "GenericError";
    LogType[LogType["NoConnection"] = 2] = "NoConnection";
    LogType[LogType["CustomError"] = 3] = "CustomError";
})(LogType || (LogType = {}));
